export default __webpack_public_path__ + "static/media/logo.0ceec6a2.svg";